var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.308 2.755a.75.75 0 0 1 .546.91l-4.253 17.033a.75.75 0 0 1-1.455-.363l4.253-17.034a.75.75 0 0 1 .91-.546ZM7.28 6.22a.75.75 0 0 1 0 1.06l-3.97 3.97 3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97a1.5 1.5 0 0 1 0-2.12l3.97-3.97a.75.75 0 0 1 1.06 0ZM16.72 15.22a.75.75 0 1 0 1.06 1.06l3.97-3.97a1.5 1.5 0 0 0 0-2.12l-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97Z"
  })));
};
export default SvgCode;